// extracted by mini-css-extract-plugin
module.exports = {"AddressesHeader":"MyAddresses_AddressesHeader__hQEaR","AddressesHolder":"MyAddresses_AddressesHolder__17iuP"};